"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayout = useLayout;
exports.LayoutProvider = exports.defaultLayout = void 0;

var _element = require("@wordpress/element");

/**
 * WordPress dependencies
 */
var defaultLayout = {
  type: 'default'
};
exports.defaultLayout = defaultLayout;
var Layout = (0, _element.createContext)(defaultLayout);
/**
 * Allows to define the layout.
 */

var LayoutProvider = Layout.Provider;
/**
 * React hook used to retrieve the layout config.
 */

exports.LayoutProvider = LayoutProvider;

function useLayout() {
  return (0, _element.useContext)(Layout);
}
//# sourceMappingURL=layout.js.map